import {
  ListItemText,
  MenuItem as MUIMenuItem,
  ListItemIcon as MuiListItemIcon,
  styled,
} from '@mui/material'
import Typography from '../../../components/Typography'
import { ScrollYPositionKeys } from '../../../util/consts'
import { saveScrollYPosition } from '../../../util/helpers'
import { useNavigate } from 'react-router-dom'
import TestIds from '../../../testIds'
import MaterialSymbol from '../../../components/MaterialSymbol'

const QuickLinkWrapper = styled('div')(({ theme }) => ({
  display: 'none',
  flexDirection: 'column',
  gap: '8px',
  width: '100%',
  [theme.breakpoints.down('md')]: {
    display: 'flex',
  },
}))

const ButtonsWrapper = styled('div')(() => ({
  display: 'flex',
  gap: '8px',
  width: '100%',
  flexDirection: 'row',
}))

const Button = styled(MUIMenuItem)(({ theme }) => ({
  backgroundColor: 'white',
  padding: '12px 8px',
  border: `1px ${theme.colors.primary100}`,
  // minWidth: '50%',
  width: '100%',
}))

interface LinkButtonProps {
  onClick: () => void
  iconId: string
  label: string
  testId: string
}

const LinkButton: React.FC<LinkButtonProps> = ({ onClick, iconId, label, testId }) => {
  return (
    <Button farmlands-variant='light' onClick={onClick} data-testid={testId}>
      <MuiListItemIcon>
        <MaterialSymbol>{iconId}</MaterialSymbol>
      </MuiListItemIcon>
      <ListItemText>{label}</ListItemText>
    </Button>
  )
}

export const QuickLinks = () => {
  const navigate = useNavigate()
  return (
    <QuickLinkWrapper>
      <Typography variant='h4'>Quick links</Typography>
      <ButtonsWrapper>
        <LinkButton
          label='Agreements'
          iconId='Note'
          testId={TestIds.components.quicklink.agreements}
          onClick={() => {
            saveScrollYPosition({
              sessionStorageKey: ScrollYPositionKeys.Agreements,
              position: 0,
            })
            navigate('/agreements')
          }}
        />
        <LinkButton
          label='Quotes'
          iconId='request_quote'
          testId={TestIds.components.quicklink.quotes}
          onClick={() => {
            saveScrollYPosition({
              sessionStorageKey: ScrollYPositionKeys.Quotes,
              position: 0,
            })
            navigate('/quotes')
          }}
        />
      </ButtonsWrapper>
    </QuickLinkWrapper>
  )
}
